<template>
  <b-row
    :class="{ 'attendance-row': isAttended }"
    class="m--0">
    <b-col
      v-if="isAttended"
      class="d-flex align-items-center"
      cols="2">
      <div class="profpict inline--block">
        <img :src="dataAttendance.image_url">
      </div>
    </b-col>
    <b-col
      v-if="isAttended"
      cols="10"
    >
      <div class="label-chekin-today">Yeah, you have check in today</div>
      <div class="proflocation">
        <i class="fa fa-map-marker"/>
        <span>{{ dataAttendance.address }}</span>
      </div>
      <h4 class="attendtime">{{ convertTimer(dataAttendance.check_in_time) }}</h4>
    </b-col>
    <b-col
      v-if="!isAttended"
      cols="2">
      <img
        src="@/assets/icon/fingerprint.png"
        height="40" >
    </b-col>
    <b-col
      v-if="!isAttended"
      cols="8"
    >
      <span>Oops, you haven't check in today</span>
      <br>
      <span
        style="font-weight: bold; font-size: 0.8em"
      >
        Lets Check In!
      </span>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable no-console */
export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    isAttended: {
      type: Boolean,
      default: false,
    },
    dataAttendance: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    };
  },
  methods: {
    convertTimer(data) {
      const date = new Date(Number(data));
      const hours = date.getHours();
      const minutes = date.getMinutes();
      return `${hours < 10 ? '0' : ''}${hours}.${minutes < 10 ? '0' : ''}${minutes}`;
    },
  },
};
</script>
<style scoped>
.profpict {
  position: relative;
  width: 100%;
  overflow:hidden;
  text-align: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  border: 2px solid #a4ceb4;
}

.profpict img{
  position:absolute;
  width:100%;
  transform: scale(1.2);
}

.profpict:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.attendtime {
  margin-bottom: 0;
}

.proflocation {
  font-size: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 18px;
  width: 100%;
  white-space: nowrap;
}

.proflocation span{
  font-size: 9px;
}

.attendance-row {
  margin-top: -10px !important;
}

.label-chekin-today {
  font-family: 'Poppins-Bold';
  line-height: 20px;
  font-size: 12px;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jAttendanceWidget.vue